'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useSession } from 'next-auth/react';
import styles from './CookieConsent.module.scss';

const STORAGE_KEY = 'cookie_consent';

export default function CookieConsent() {
  const { data: session } = useSession();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        const timer = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  const persistChoice = async (accepted: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'declined');
    } catch {
      // ignore
    }

    if (accepted && session?.user) {
      try {
        await fetch('/api/v1/me/cookie-consent', {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cookieConsent: true }),
        });
      } catch {
        // Non-critical
      }
    }

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.overlay} role="dialog" aria-label="Cookie consent" aria-live="polite">
      <div className={styles.banner}>
        <div className={styles.header}>
          <span className={styles.iconWrap} aria-hidden="true">🍪</span>
          <p className={styles.title}>We use cookies</p>
        </div>

        <p className={styles.description}>
          We use cookies to improve your experience and analyse traffic.{' '}
          <Link href="/cookie-policy" className={styles.policyLink}>Cookie Policy</Link>
          {' · '}
          <Link href="/privacy" className={styles.policyLink}>Privacy</Link>
        </p>

        <div className={styles.actions}>
          <button
            id="btn-cookie-decline"
            className={styles.btnDecline}
            onClick={() => persistChoice(false)}
          >
            Decline
          </button>
          <button
            id="btn-cookie-accept"
            className={styles.btnAccept}
            onClick={() => persistChoice(true)}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
